angular.module('user')
    .directive('userPickerMulti', function($filter, $document, $compile, $parse, User) {
        return {
            restrict: 'AE',
            require: '?ngModel',
            scope: {
                onChange: "&",
            },
            templateUrl: "app/user/user-picker-multi.html",
            link: function(scope, $element, $attrs, ngModelCtrl) {

                scope.executeOnChange = scope.onChange || angular.noop
                scope.selected = ngModelCtrl.$modelValue || [];
                scope.users = [];
                let activeUsers = [];

                User.autocomplete().$promise.then(items => {
                    activeUsers = items;
                    refreshAvailableUsers();
                });

                function refreshAvailableUsers() {
                    const selectedUsers = angular.isArray(scope.selected) ? scope.selected : [];
                    const inactiveSelectedUsers = selectedUsers.filter(selectedUser =>
                        !activeUsers.some(activeUser => activeUser.id === selectedUser.id)
                    );
                    scope.users = inactiveSelectedUsers.concat(activeUsers);
                }

                scope.usersDropdownSettings = {
                    searchField: 'fullName',
                    enableSearch: true,
                    displayProp: 'fullName',
                    idProperty: 'id',
                    scrollable: true,
                    keyboardControls: true,
                    template: '<span class="user-picker-multi__option" ng-class="{\'user-picker-multi__option--inactive\': option.activated === false}"><span>{{option.fullName}}</span> <span class="text-danger bold" ng-if="option.activated === false" uib-tooltip="Nieaktywny">N</span></span>',
                    // styleActive: true
                };

                scope.dropdownMultiselectTranslations = {
                    checkAll: 'Zaznacz wszystko',
                    uncheckAll: 'Odznacz wszystko',
                    buttonDefaultText: '-- wybierz --',
                    searchPlaceholder: "szukaj..."
                };


                scope.$watchCollection(function(){ return ngModelCtrl.$modelValue; }, function(newValue, oldValue) {
                    if (oldValue != newValue){
                        //update the view value with fresh data from items, if there is a valid model value
                        if(angular.isDefined(ngModelCtrl.$modelValue)) {
                            ngModelCtrl.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
                        }
                        scope.seleced = ngModelCtrl.$modelValue;
                    }
                });
                ngModelCtrl.$render = () => {
                    // Make sure that model value is array
                    if(!angular.isArray(ngModelCtrl.$viewValue)){
                        // Have tolerance for null or undefined values
                        if(angular.isUndefined(ngModelCtrl.$viewValue) || ngModelCtrl.$viewValue === null){
                            ngModelCtrl.$viewValue = [];
                        } else {
                            throw Exception("Expected model value to be array but got '{0}'", ngModelCtrl.$viewValue);
                        }
                    }
                    scope.selected = ngModelCtrl.$viewValue;
                    refreshAvailableUsers();
                };

                scope.$watchCollection('selected', refreshAvailableUsers);

                ngModelCtrl.$isEmpty = modelValue => !angular.isArray(modelValue) || modelValue.length === 0;

                scope.events = {
                    onSelectionChanged : () => {
                        ngModelCtrl.$setDirty();
                        ngModelCtrl.$setViewValue(scope.selected);
                        ngModelCtrl.$validate();
                        if(angular.isFunction(scope.executeOnChange())){
                            scope.executeOnChange()(scope.selected);
                        }
                    }
                }

            }
        };
    })
